module.exports = __webpack_public_path__ + "static/media/first-lithonia-check-up-heart.3b82c85e.jpg";